<template>
  <div id="Tab6">
    <ValidationObserver ref="formValidator">
      <SectionTitle
        icon="fas fa-address-card"
        content="VI. Otras Consideraciones y Servicios"
        container-class="tag-badge-main-info mt-5 mb-4"
      />

      <Error
        v-if="controversyVI && controversyVI.existControversy"
        is-alert-mode
        :message="
          '<b>Parte en Controversia: </b>' + controversyVI.informationMessage
        "
      />

      <div class="row mb-4">
        <div class="col">
          <SectionTitle
            has-line
            content="F. Acomodos que necesita el estudiante para participar en el proceso de enseñanza y aprendizaje"
            container-class="mb-4"
          />
          <Error
            v-if="validateWithtoutArrangement()"
            is-alert-mode
            class="mt-0"
            :message="
              '<b>Según la definición del PEI el estudiante no necesitará de acomodos.</b>'
            "
          />
          <LearningArrangement
            v-if="!validateWithtoutArrangement()"
            :area-list="areaList"
            :arrangement="arrangement"
            :is-draft="
              !isPsc &&
                isDraft &&
                canEditTab6 &&
                (admendmentIsEmpty ||
                  !canUseTabEditRestriction ||
                  hasSubSectionFinAmendant)
            "
            @onFilterArrangement="fetchArrengementListByArea"
            @onSaveArrangement="saveArrangementList($event)"
            @onRemoveArrangement="removeFromArrangementList"
            @onItemSelectedArrangement="selectArrangement"
            @fetchArrangement="fetchSelectedArrangementList"
          />

          <Error
            v-if="validateLearningArrangement()"
            variant="no-border"
            :message="validationMessages['6006']"
          />
        </div>
      </div>

      <div v-show="showProgramMeasurement" class="row">
        <div class="col">
          <div>
            <SectionTitle
              :has-line="true"
              content="G. Programa de Medición por el cual se evaluará el proceso académico y funcional del estudiante"
              container-class="mb-4"
            />
            <div v-if="peiOtherServMeasureCode.isRegular">
              <div class="ml-2 mt-3 d-block">
                <StrongTitle title="Programa de Mediación Regular: " />
                <span v-if="model.otherServMeasurePlacementFlag === '1'">
                  Con acomodos
                </span>
                <span v-if="model.otherServMeasurePlacementFlag === '0'">
                  Sin acomodos
                </span>
              </div>
              <MeasurementProgramStudent
                :programmeasure="programMeasurementList"
              />
            </div>
            <div
              v-if="peiOtherServMeasureCode.isEvaluacionAlterna"
              class="ml-3 my-4 d-block"
            >
              <div class="custom-control custom-checkbox">
                <input
                  id="customCheck2"
                  type="checkbox"
                  class="custom-control-input"
                  :checked="true"
                  :disabled="true"
                />
                <label class="custom-control-label" for="customCheck2">
                  Evaluación Alterna: Alineada con estándares de aprovechamiento
                  alternos
                </label>
              </div>
            </div>
          </div>
          <MeasurementProgramStudentAdd
            v-if="hasMeasurement"
            ref="measurementprogramadd"
            :area-list="areaList"
            :measurements="measurements"
            @on-save="onSaveMeasurement"
            @close="onCloseMeasurementProgram"
            @fecthMeasurements="fetchAccomodationsByArea"
          />

          <Error
            v-if="validateMeasurementProgramStudent()"
            variant="no-border pb-4"
            :message="validationMessages['6006']"
          />
        </div>
      </div>
      <div class="row">
        <div class="col">
          <SectionTitle
            :has-line="true"
            content="H. Si el estudiante no participará en el programa de medición regular, explique las razones y por qué la evaluación alterna es apropiada"
            container-class="mb-4"
          />
          <ValidationProvider
            v-slot="{ invalid }"
            :rules="
              `${
                !validationTriggered.validation &&
                hasValidate &&
                peiOtherServMeasureCode.isEvaluacionAlterna &&
                !isOtherServMeasureCodeNoApplicable
                  ? 'required'
                  : ''
              }`
            "
            name=" "
          >
            <CustomTextArea
              :id="'medicionRegular'"
              v-model="model.serviceArrangementProgMeasureDescription"
              :placeholder="
                `${
                  peiOtherServMeasureCode.isEvaluacionAlterna
                    ? 'Escribir razones...'
                    : ''
                }`
              "
              :maxlength="3000"
              :custom-error-msg="errorMsgs['Requerido']"
              :error="`${invalid ? 'error' : ''}`"
              :rows="5"
              :disabled="
                isPsc ||
                  isOtherServMeasureCodeNoApplicable ||
                  ((!peiOtherServMeasureCode.isEvaluacionAlterna ||
                    !isDraft ||
                    !canEditTab6 ||
                    !hasSubSectionGinAmendant) &&
                    canUseTabEditRestriction &&
                    !admendmentIsEmpty) ||
                  !isDraft
              "
            />
          </ValidationProvider>
        </div>
      </div>
      <div class="row separator-space">
        <div class="col">
          <SectionTitle
            :has-line="true"
            content="I. Necesidades de Servicio o de apoyo al estudiante que serán atendidas en el ámbito escolar"
            container-class="mb-4"
          />
          <NeedsStudent
            v-if="!hasSelectedNeedsStudent"
            :rows="needsStudentList"
            :validate="validateSAEE10Form"
            :activateAssistantServiceNeedGuideParam="
              (isDraft && activateAssistantServiceNeedGuideIsOn) ||
                showSectionOfAssistanceWhenIsSigned
            "
            :is-draft="
              isDraft &&
                canEditTab6 &&
                (admendmentIsEmpty ||
                  !canUseTabEditRestriction ||
                  hasSubSectionIinAmendant)
            "
            :selected-interpreter-level="selectedInterpreterLevelText"
            :can-delete="!isPsc"
            :inappropriate-conduct-alternative="
              selectedInappropriateConductAlternative
            "
            @save="saveNeedsStudentHandler"
            @delete="deleteNeedsStudentHandler"
            @on-justified-flag-change="onJustifiedFlagChangeHandler"
          />
          <div style="position:relative">
            <Error
              style="position:absolute"
              v-if="
                validationTriggered.validation &&
                  validationTriggered.hasErrors('Tab6', 'NeedGuide-Saee14-doc')
              "
              message="Favor de anejar el documento SAEE-14 Evaluación Funcional de la Conducta"
              variant="withoutspacing no-border pt-16"
            />
          </div>
          <Error
            v-if="
              validationTriggered.validation &&
                validationTriggered.hasErrors('Tab6', 'ICN')
            "
            :message="validationTriggered.errors('Tab6', 'ICN')"
            variant="withoutspacing no-border pt-16"
          />

          <NeedsStudentAdd
            v-if="hasSelectedNeedsStudent"
            ref="needstudentadd"
            :needs-type-list="needsStudentTypeList"
            :activateAssistantServiceNeedGuideParam="
              (isDraft && activateAssistantServiceNeedGuideIsOn) ||
                showSectionOfAssistanceWhenIsSigned
            "
            :interpeter-level-list="interpeterLevelList"
            :is-draft="
              isDraft &&
                canEditTab6 &&
                (admendmentIsEmpty ||
                  !canUseTabEditRestriction ||
                  hasSubSectionIinAmendant)
            "
            :selected-interpreter="selectedInterpreterLevelCode"
            @save="saveNeedsStudentAddHandler"
            @delete="deletetNeedsStudentAddHandler"
            @close="closeNeedsStudentAddHandler"
          />
          <Error
            v-if="validateNeedsStudent()"
            variant="no-border"
            :message="validationMessages['6010']"
          />
        </div>
      </div>
      <div
        v-if="canShowSaee10Section"
        class="d-flex flex-column mt-4 border rounded"
      >
        <div class="d-flex py-3 px-4 service-assistance-needs-title">
          <i class="fas fa-list-alt text-green" />
          <h3 class="ml-3">
            SAEE-10 Análisis de necesidad para asistencia de servicios
          </h3>
        </div>

        <div class="p-4">
          <ValidationProvider
            v-slot="{ invalid }"
            :rules="
              validateSAEE10Form ||
              (needsStudentList && needsStudentList.lenght)
                ? 'required'
                : ''
            "
          >
            <CustomTextArea
              id="serviceNeedsCommentsTA"
              v-model="model.serviceNeedsComments"
              :placeholder="'Escribe la justificación del servicio'"
              :maxlength="3000"
              :custom-error-msg="errorMsgs['Requerido']"
              :error="`${invalid ? 'error' : ''}`"
              :count-classes="['d-block text-right']"
              :rows="5"
              :disabled="isReadonlyWithAmendmentSectionI"
            />
          </ValidationProvider>

          <Hygiene
            v-if="hasHygieneNeeds"
            v-model="hygieneModel"
            :validable="validateSAEE10Form"
            class="border-bottom"
            :canDelete="!isPsc && !isReadonlyWithAmendmentSectionI"
            :disabled="isReadonlyWithAmendmentSectionI"
            @delete="
              deleteNeedsStudentHandler(
                getServiceNeedsItem(serviceNeedsItems.Hygiene)
              )
            "
          />

          <Nutrition
            v-if="hasNutritionNeeds"
            v-model="nutritionModel"
            :validable="validateSAEE10Form"
            class="border-bottom"
            :canDelete="!isPsc && !isReadonlyWithAmendmentSectionI"
            :disabled="isReadonlyWithAmendmentSectionI"
            @delete="
              deleteNeedsStudentHandler(
                getServiceNeedsItem(serviceNeedsItems.Nutrition)
              )
            "
          />

          <Mobility
            v-if="hasMobilityNeeds"
            v-model="mobilityModel"
            :validable="validateSAEE10Form"
            class="border-bottom"
            :canDelete="!isPsc && !isReadonlyWithAmendmentSectionI"
            :disabled="isReadonlyWithAmendmentSectionI"
            @delete="
              deleteNeedsStudentHandler(
                getServiceNeedsItem(serviceNeedsItems.Mobility)
              )
            "
          />

          <Communication
            v-if="hasCommunicationNeeds"
            v-model="communicationModel"
            :validable="validateSAEE10Form"
            class="border-bottom"
            :limitation-domain-level-options="limitationDomainLevelOptions"
            :canDelete="!isPsc && !isReadonlyWithAmendmentSectionI"
            :disabled="isReadonlyWithAmendmentSectionI"
            @delete="
              deleteNeedsStudentHandler(
                getServiceNeedsItem(serviceNeedsItems.Communication)
              )
            "
          />
          <Health
            v-if="hasHealthNeeds"
            v-model="healthModel"
            :validable="validateSAEE10Form"
            :items="needsStudentList"
            :key="needsStudentList.length"
            class="border-bottom"
            :canDelete="!isPsc && !isReadonlyWithAmendmentSectionI"
            @delete="deleteNeedsStudentHandlerByArray"
            :disabled="isReadonlyWithAmendmentSectionI"
          />
          <Transportation
            v-if="hasTransportationNeeds"
            v-model="transportationModel"
            :validable="validateSAEE10Form"
            class="border-bottom"
            :canDelete="!isPsc && !isReadonlyWithAmendmentSectionI"
            :disabled="isReadonlyWithAmendmentSectionI"
            @delete="
              deleteNeedsStudentHandler(
                getServiceNeedsItem(serviceNeedsItems.Transportation)
              )
            "
          />
        </div>
      </div>

      <div class="row separator-space">
        <div class="col">
          <SectionTitle
            :has-line="true"
            content="J. Modificaciones al programa y apoyos para el personal que trabaja con el estudiante, en beneficio de éste"
            container-class="mb-4"
          />
          <ModificationsProgramStudent
            :modifications-list="modifications"
            :is-draft="!isPsc && !isReadonlyWithAmendmentSectionI"
            @refresh="fetchServiceModifications"
          />
        </div>
      </div>
    </ValidationObserver>
  </div>
</template>

<script>
import { SectionTitle } from '@/components/pei/shared';
import {
  StrongTitle,
  MeasurementProgramStudent,
  MeasurementProgramStudentAdd,
  NeedsStudent,
  NeedsStudentAdd,
  ModificationsProgramStudent,
  Hygiene,
  Nutrition,
  Mobility,
  Communication,
  Health,
  Transportation,
} from '@/components/pei/tabs/components/tab6';
import LearningArrangement from '@/components/pei/tabs/components/tab6/LearningArrangement';
import store from '@/store/index';
import mixAlert from '@/mixin/alert.mixin';
import mixWait from '@/mixin/loading.mixin';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import peiOtherServMeasuresEnum from '@/utils/constants/pei/peiOtherServMeasures';
import peiStatuses from '@/utils/constants/pei/peiStatus';
import CustomTextArea from '@/components/common/CustomTextArea';
import SaveObserver from '@/components/common/SaveObserver';
import Error from '@/components/common/Error';
import peiSections from '@/utils/constants/pei/peiSections.js';
import peiServiceNeeds from '@/utils/constants/pei/peiServiceNeeds.js';
import peiServiceNeedCodes from '@/utils/constants/hrrequest/peiServiceNeedCodes';
// Services.
import resourcesService from '@/services/resources.js';
import studentService from '@/services/student.js';
import peiGeneralService from '@/services/pei/general';
import { getSysparameterByNames } from '@/modules/system-parameter-managment/api';
import peiAssistantsNeeds from '@/utils/constants/pei/peiAssistantsNeeds';
import peiCode from '@/utils/constants/pei/peiCode';
import needsService from '@/services/pei/serviceNeedQuestionnaire';
import AnswerType from '@/utils/constants/pei/serviceNeedQuestionnaire/answerType';
import peiProgramAreas from '@/utils/constants/pei/peiProgramAreas';
import { ImpedimentEnum } from '@/components/triannualDeterminationProcess/components/impediments/common/ImpedimentEnum.js';
import { getIfHasSubmittedInfo } from '@/modules/peiSAEE/api';
const necesityTypeWithOptions = Object.freeze({
  Interpreter: 2071,
});
const Questions = {
  DoesStudentUsesWheelchairForMovingOneToAnotherPlace: 9,
  DoesTheStudentUseMotorizedWheelchair: 10,
  IsStudentAbleToMoveAroundOnHisHerOwn: 11,
};
const YES = '1';
const SUB_SECTION_F = 38;
const SUB_SECTION_G = 39;
const SUB_SECTION_I = 48;
const SUB_SECTION_J = 49;

const healtNeedsCodes = Object.freeze([
  peiServiceNeeds.healthAnxiety,
  peiServiceNeeds.healthsupportForHealthNeeds,
  peiServiceNeeds.healthCatheterization,
  peiServiceNeeds.healthColostomy,
  peiServiceNeeds.healthDiabetes,
  peiServiceNeeds.healthGastrostomy,
  peiServiceNeeds.healthMedication,
  peiServiceNeeds.MedicationAdministration,
]);

const hygieneModelDefault = {
  requiresDiaperChange: null,
  requiresTraining: null,
  comment: '',
};

const nutritionModelDefault = {
  nutritionStudentRequireAssistanceToEat: null,
  nutritionStudentRequireAssistanceWithYourGastronomy: null,
  nutritionComments: null,
};

const mobilityModelDefault = {
  hasImpediment: null,
  isImpedimentPermanent: null,
  requiresEquipmentHelp: null,
  studentEquipmentId: null,
  isBlind: null,
  comment: null,
};

const healthModelDefault = {
  studentHasImpediment: null,
  studentNeedSpecialAttention: null,
  studentInappropriateConduct: null,
  comments: null,
};

const communicationModelDefault = {
  diapersRequired: null,
  severelyLimitedLanguageRequired: null,
  limitationDomainLevel: null,
  comment: null,
};

const transportationModelDefault = {
  comment: null,
  hasSignificantDisability: null,
  travelUnsupervisedRequired: null,
};

const CommunicationOptions = [
  peiServiceNeeds.Communication,
  peiServiceNeeds.CommunicationV2,
];

var canUpdate = false;
const setFormDef = function(val) {
  if (canUpdate) {
    store.commit('setFormDirty', {
      value: val,
    });
  }
};
export default {
  name: 'Tab6PEI',
  mixins: [mixAlert, mixWait],
  data() {
    return {
      model: {
        serviceArrangementProgMeasureDescription: '',
        peiOtherServMeasureCode: null,
        placementFlag: null,
        otherServMeasurePlacementFlag: null,
        serviceAdditionalInfo: null,
        serviceNeedsComments: null,
      },
      peiId: store.getters.SelectedPei,
      errorMsgs: {
        Requerido: 'El campo es requerido',
      },
      hasValidate: false,
      alternateNeedDescriptionReson:
        'Generalmente no puede demostrar su conocimiento y dominio de destrezas mediante la participación del programa de medición regular aun cuando se le provean los acomodos necesarios y el uso de equipo asisitivos.',
      peiOtherServMeasureCode: {
        isRegular: false,
        isEvaluacionAlterna: false,
      },
      hasMeasurement: false,
      measurements: [],
      showProgramMeasurement: false,
      programMeasurementList: [],
      hasSelectedNeedsStudent: false,
      needsStudentList: [],
      needsStudentListInterpeterLevel: [],
      needsStudentTypeList: [],
      interpeterLevelList: [],
      selectedInterpreterLevelCode: 0,
      selectedInterpreterLevelText: null,
      modifications: [],
      wasSignedWithaAssistantServiceNeedGuide: false,
      arrangement: {
        name: 'ServiceArrangement',
        isModified: false,
        items: [],
        selected: [],
        temporary: [],
        grouped: [],
      },
      areaList: [],
      showFooterBar: false,
      validationMessages: {},
      canEditTab6: store.getters.HasPermission('pei.editTab6'),
      hygieneModel: hygieneModelDefault,
      nutritionModel: nutritionModelDefault,
      mobilityModel: mobilityModelDefault,
      healthModel: healthModelDefault,
      communicationModel: communicationModelDefault,
      limitationDomainLevelOptions: [],
      transportationModel: transportationModelDefault,
      serviceNeedsItems: peiServiceNeeds,
      sysParameters: [],
      hasInapropriateConduct: false,
      activateAssistantServiceNeedGuideIsOn: false,
      studentFunctionData: null,
    };
  },
  async activated() {
    await this.loadAllData();
    await this.getStudentFunction();
    store.commit('setSaveMethod', this.save);
    store.commit('setSaveBtnVisibility', true);
    canUpdate = false;
  },
  beforeDestroy() {
    canUpdate = false;
  },
  methods: {
    async loadAllData() {
      return Promise.all([
        this.getSysParam(),
        this.getSelectedNeedsStudent(),
        this.loadResources(),
        this.fetchAreaList(),
        this.getCommunicationLevelLimitationOptions(),
        this.getHasSubmittedInfo(),
        this.fetchSelectedArrangementList(),
        this.fetchServiceModifications(),
        this.getOtherConsiderationMeasure(),
      ]);
    },
    async getSysParam() {
      const academicYearId = store.getters.getPeiInfo.academicYearId;
      const { data: sysParameters } = await getSysparameterByNames({
        parameterNames: ['PEIServicesNeedsSAEE10'],
        academicYearId,
      });
      this.sysParameters = sysParameters;
      this.getActivateAssistantServiceNeedGuidearameter();
    },
    async getHasSubmittedInfo() {
      const { data } = await getIfHasSubmittedInfo(this.peiId);
      this.wasSignedWithaAssistantServiceNeedGuide = data;
    },
    async getStudentFunction() {
      const { data } = await peiGeneralService.getStudentFunction(this.peiId);
      this.hasInapropriateConduct = data.configInapropriateConductFlag == YES;
      this.studentFunctionData = { ...data };
    },
    async getCommunicationLevelLimitationOptions() {
      const { data } = await this.$ApiGet(
        `/api/pei/CommunicationLevelLimitationOptions`
      );
      this.limitationDomainLevelOptions = data.map((x) => ({
        label: x.name,
        value: x.id,
      }));
    },
    async getOtherConsiderationMeasure() {
      const { data } = await this.$ApiGet(
        `/api/pei/${this.peiId}/OtherConsiderationsMeasure`
      );
      if (data == null) {
        return;
      }

      this.model = data;
      this.onSetMeasure();
    },
    onSetMeasure() {
      if (this.model.peiOtherServMeasureCode) {
        if (
          this.model.peiOtherServMeasureCode ===
          peiOtherServMeasuresEnum.Regular
        ) {
          // Regular = 16
          this.peiOtherServMeasureCode.isRegular = true;
        } else if (
          this.model.peiOtherServMeasureCode ===
          peiOtherServMeasuresEnum.EvaluacionAlterna
        ) {
          // EvaluacionAlterna = 17
          this.peiOtherServMeasureCode.isEvaluacionAlterna = true;
        }

        this.initWhySelectNeed();
        this.initProgramMeasurement();
      }
    },
    async save(showtoast = null) {
      this.hasValidate = this.peiOtherServMeasureCode.isEvaluacionAlterna;

      if (this.hasValidate) {
        this.hasValidate = false;
      }

      this.model.serviceAdditionalInfo = {
        hygiene: this.hygieneModel,
        nutrition: this.nutritionModel,
        mobility: {
          ...this.mobilityModel,
          studentEquipmentId: this.mobilityModel.studentEquipmentId
            ? Number(this.mobilityModel.studentEquipmentId)
            : null,
        },
        communication: this.communicationModel,
        health: this.healthModel,
        transportation: this.transportationModel,
      };

      try {
        await this.$ApiPost(
          `/api/pei/${this.peiId}/OtherConsiderationsMeasure`,
          this.model
        );
        if (!showtoast) {
          this.ShowToast(
            this.validationMessages['R03200110'],
            this.validationMessages['R03200109'],
            'success'
          );
        }
      } catch (err) {
        const message = err?.response?.data?.message ?? err?.message;
        this.ShowToast(message, '', 'error');
      }
    },
    onAddMeasurement() {
      this.hasMeasurement = true;
    },
    onSaveMeasurement() {
      const self = this;
      let ids = [];

      self.measurements = this.$refs.measurementprogramadd.added;

      ids = self.measurements.map((i) => i.id);

      self
        .$ApiPost('api/pei/AddPeiServiceArrangement', {
          PeiId: store.state.peiSelected,
          PeiCodes: ids,
        })
        .then(() => {
          self.hasSelectedNeedsStudent = false;
          self.measurements = self.measurements.map((obj) => ({ ...obj }));
        })
        .catch((errm) => {
          self.ShowToast(errm.message, '', 'error');
        })
        .finally(() => {
          self.hasMeasurement = false;
          self.getSelectedNeedsStudent();
        });
    },
    unselectAccomodationHandler(data) {
      if (data) {
        this.learningAccomodations[data.index].accommodations.splice(
          this.learningAccomodations[data.index].accommodations.indexOf(
            data.item
          ),
          1
        );
      }
    },

    initProgramMeasurement() {
      if (this.peiOtherServMeasureCode.isRegular) {
        this.getServiceArrangementProgramMeasure();
      }

      this.showProgramMeasurement = true;
    },
    getServiceArrangementProgramMeasure() {
      const self = this,
        params = {
          peiId: this.peiId,
        };

      self.$ApiGet('api/pei/programmeasure', params).then((res) => {
        let data = res.data;

        if (data) {
          self.programMeasurementList = data;
        }
      });
    },

    async getSelectedNeedsStudent() {
      try {
        const { data } = await this.$ApiGet(
          'api/pei/GetSelectedPeiServiceNeed',
          { peiId: this.peiId }
        );

        if (!data) {
          return;
        }

        this.needsStudentList = data.map((item) => ({
          id: item.id,
          name: item.name,
          isJustifiedNeed: item.justifiedFlag,
          hasIcon: false,
        }));

        this.hygieneModel =
          data.find((c) => c.id == peiServiceNeeds.Hygiene)?.hygiene ??
          hygieneModelDefault;

        this.nutritionModel =
          data.find((c) => c.id == peiServiceNeeds.Nutrition)?.nutrition ??
          nutritionModelDefault;

        this.mobilityModel =
          data.find((c) => c.id == peiServiceNeeds.Mobility)?.mobility ??
          mobilityModelDefault;

        if (this.mobilityModel && this.mobilityModel.studentEquipmentId) {
          this.mobilityModel.studentEquipmentId = this.mobilityModel.studentEquipmentId.toString();
        }

        this.communicationModel =
          data.find((c) => CommunicationOptions.includes(c.id))
            ?.communication ?? communicationModelDefault;

        this.healthModel =
          data.find((c) => healtNeedsCodes.includes(c.id))?.health ??
          healthModelDefault;

        this.transportationModel =
          data.find((c) => c.id == peiServiceNeeds.Transportation)
            ?.transportation ?? transportationModelDefault;

        this.selectedInterpreterLevelCode = data.find(
          (x) =>
            x.peiInterpreterLevelCode > 0 && CommunicationOptions.includes(x.id)
        )?.peiInterpreterLevelCode;

        if (this.selectedInterpreterLevelCode > 0) {
          this.getInterpeterLevelList();
          return;
        }

        this.selectedInterpreterLevelText = null;
      } catch (err) {
        this.ShowToast(err.message, '', 'error');
      }
    },
    saveNeedsStudentHandler() {
      this.hasSelectedNeedsStudent = true;
      // Uso de next tick para dar tiempo al cambio de renderizacion que aparezca
      // componente luego de darle valor true a hasSelectedNeedsStudent
      this.$nextTick(() => {
        this.$refs.needstudentadd.added = [...this.needsStudentList];
      });
      this.getNeedsTypeList();
      this.getInterpeterLevelList();
    },
    async onJustifiedFlagChangeHandler(item) {
      await this.$ApiPut('api/pei/UpdateJustifiedNeedFlag', item);

      const peiNeed = this.needsStudentList.find((x) => x.id === item.peiCode);

      peiNeed.isJustifiedNeed = item.justifiedFlag;
    },
    async deleteNeedsStudentHandler(item) {
      const params = {
        peiId: this.peiId,
        peiCode: item.id,
      };
      let hasTransportationAssistant = this.needsStudentList.find(
        (x) => x.id == peiAssistantsNeeds.transportacion
      );
      if (
        item.id == peiAssistantsNeeds.sillaDeRueda &&
        hasTransportationAssistant
      ) {
        let confirmDeletion = await this.ShowCancelModal(
          'Atención',
          `Al remover el servicio de Asistente para Silla de Ruedas se estará eliminado también el Asistente para transportación ¿Estas seguro?`,
          'Si',
          'No'
        );
        if (!confirmDeletion) return;

        const params = {
          peiId: this.peiId,
          peiCode: peiAssistantsNeeds.transportacion,
        };
        await this.$ApiDelete('api/pei/DeletePeiServiceNeed', params);
      }

      await this.$ApiDelete('api/pei/DeletePeiServiceNeed', params);
      await this.getSelectedNeedsStudent();

      var hasNeeds =
        this.needsStudentList.filter(
          (x) => x.id != peiServiceNeeds.IsNotRequired
        ).length > 0;
      if (!hasNeeds) {
        this.model.serviceNeedsComments = null;
      }
    },
    deleteNeedsStudentHandlerByArray(item) {
      item.forEach((element) => {
        this.deleteNeedsStudentHandler(element);
      });
    },
    getServiceNeedsItem(peiServiceNeedId) {
      return this.needsStudentList.find((c) => c.id == peiServiceNeedId);
    },
    async getNeedsTypeList() {
      const { data } = await peiGeneralService.getAllPeiServiceNeed(this.peiId);

      if (data) {
        this.needsStudentTypeList = data.filter(
          (e) => !this.needsStudentList.map((x) => x.id).includes(e.id)
        );
      }
    },
    async getInterpeterLevelList() {
      const {
        data,
      } = await peiGeneralService.getPeiServiceNeedInterpreterLevel();

      if (data) {
        this.interpeterLevelList = data;
        this.selectedInterpreterLevelText = this.interpeterLevelList.find(
          (x) => x.id == this.selectedInterpreterLevelCode
        )?.name;
      }
    },
    async saveNeedsStudentAddHandler() {
      await this.save(1);
      const self = this;
      const list = self.$refs.needstudentadd.added;
      self.needsStudentListInterpeterLevel = this.$refs.needstudentadd.interpeterLevelListSelected;
      let ids = list.map((i) => i.id),
        params = {
          peiId: this.peiId,
          peiCodes: ids,
          peiInterpeterLevelCode: self.needsStudentListInterpeterLevel?.id,
        };
      const justify = await this.getQuestions();
      const serviceNeed = list.find(
        (x) => x.id == peiServiceNeedCodes.notConsideredAssistant
      );
      const hasAssistantWheelsChair = list.find(
        (x) => x.id == peiAssistantsNeeds.sillaDeRueda
      );
      const hasTransportationAssistant = list.find(
        (x) => x.id == peiAssistantsNeeds.transportacion
      );
      const hasMobilityAssistant = list.some(
        (x) => x.id == peiAssistantsNeeds.movilidad
      );
      const hasConductualSupport = list.some(
        (x) => x.id == peiAssistantsNeeds.apoyoConductual
      );

      if (hasMobilityAssistant) {
        const isDisabledStudent = await this.validateStudentHasHearingLossOrVisualDisability();
        const isValidInterventionPlan = await this.validateStudentHasInterventionPlanInOrientationAndMobility();

        // if (!isDisabledStudent && this.activateAssistantServiceNeedGuideIsOn) {
        //   this.ShowToast(
        //     'No es posible seleccionar el asistente, ya que el impedimento del estudiante no es Ciego, Sordociego o Impedimentos Múltiples.',
        //     '',
        //     'error'
        //   );
        //   return;
        // }
        if (
          !isValidInterventionPlan &&
          this.activateAssistantServiceNeedGuideIsOn
        ) {
          this.ShowToast(
            'No es posible seleccionar el asistente, ya que no cuenta con un Plan de Intervención el área de Orientación y Movilidad. Para completar el mismo de ir al Tab IV-V.',
            '',
            'error'
          );
          return;
        }
      }
      if (hasConductualSupport && this.activateAssistantServiceNeedGuideIsOn) {
        const hasValidInappropiateConduct =
          this.isInapropriateConductChecked &&
          !!this.selectedInappropriateConductAlternative &&
          this.getStudentFunctionData?.hasAtLeastOneInappropriateBehavior;

        if (!hasValidInappropiateConduct) {
          this.ShowToast(
            'No es posible seleccionar el asistente, ya que no cuenta con plan conductual documentado.',
            '',
            'error'
          );
          return;
        }
      }

      if (serviceNeed && list.length > 1) {
        self.ShowToast(
          `Al seleccionar ${serviceNeed.name}, no es posible añadir un Asistente.`,
          '',
          'error'
        );
        return;
      }

      self
        .$ApiPost('api/pei/AddPeiServiceNeed', params)
        .then(() => {
          self.hasSelectedNeedsStudent = false;
        })
        .catch((err) => {
          self.ShowToast(err.message, '', 'error');
        })
        .finally(() => {
          self.getSelectedNeedsStudent();
        });
    },
    async getQuestions() {
      const _questions = await needsService.getQuestions({
        peiId: this.peiId,
        peiCodeId: peiCode.AsistenteSillaRuedas,
      });
      const justify =
        _questions.find(
          (p) =>
            p.id ===
              Questions.DoesStudentUsesWheelchairForMovingOneToAnotherPlace &&
            p.submittedAnswerTypeId === AnswerType.Yes
        ) &&
        _questions.find(
          (p) =>
            p.id === Questions.DoesTheStudentUseMotorizedWheelchair &&
            p.submittedAnswerTypeId === AnswerType.No
        ) &&
        _questions.find(
          (p) =>
            p.id === Questions.IsStudentAbleToMoveAroundOnHisHerOwn &&
            p.submittedAnswerTypeId === AnswerType.No
        )
          ? true
          : false;
      return justify;
    },
    async deletetNeedsStudentAddHandler(item) {
      if (this.needsStudentList.some((need) => need.id === item.id)) {
        await this.deleteNeedsStudentHandler(item);
        await this.getNeedsTypeList();
      }
    },
    closeNeedsStudentAddHandler() {
      this.hasSelectedNeedsStudent = false;
    },

    initWhySelectNeed() {
      if (this.peiOtherServMeasureCode.isEvaluacionAlterna) {
        this.model.serviceArrangementProgMeasureDescription = this.model
          .serviceArrangementProgMeasureDescription
          ? this.model.serviceArrangementProgMeasureDescription
          : this.alternateNeedDescriptionReson;
      } else {
        this.model.serviceArrangementProgMeasureDescription = '';
      }
    },
    onCloseMeasurementProgram() {
      this.hasMeasurement = false;
    },
    // START Arrangements
    fetchAreaList() {
      const self = this;
      self
        .$ApiGet('api/code/getarrangmentarea')
        .then((response) => {
          self.areaList = response.data;
        })
        .catch((errm) => {
          self.ShowToast(errm.message, '', 'error');
        });
    },
    fetchArrengementListByArea(selectedArea) {
      if (selectedArea) {
        const self = this;
        self
          .$ApiGet(`api/code/getallpeiservicearrangement/${selectedArea.id}`)
          .then((response) => {
            if (self.arrangement.selected != null) {
              response.data = response.data.filter(
                (e) =>
                  !self.arrangement.selected
                    .map((x) => x.arrangementId)
                    .includes(e.id)
              );
            }
            self.arrangement.items = response.data;
          })
          .catch((errm) => {
            self.ShowToast(errm.message, '', 'error');
          });
      }
    },
    fetchSelectedArrangementList() {
      const self = this;
      self
        .$ApiGet(
          `api/pei/getallpeiservicearrangement/${store.state.peiSelected}`
        )
        .then((response) => {
          self.arrangement.selected = response.data;
          self.arrangement.grouped = response.data.reduce((r, a) => {
            r[a.areaName] = [...(r[a.areaName] || []), a];
            return r;
          }, {});
        })
        .catch((errm) => {
          self.ShowToast(errm.message, '', 'error');
        });
    },
    selectArrangement(item) {
      this.arrangement.temporary.map((s) => {
        if (s.id === item.id) {
          s.highlight = true;
        }
      });
    },
    saveArrangementList(data) {
      const self = this;
      let ids = [];

      ids = self.arrangement.temporary
        .filter((i) => !self.arrangement.selected.find((e) => e.id === i.id))
        .map((i) => i.id);

      self
        .$ApiPost('api/pei/AddPeiServiceArrangement', {
          PeiId: store.state.peiSelected,
          PeiCodes: ids,
          EnlargedFontSize: Number(data.enlargedFontSize) ?? null,
        })
        .then(() => {
          self.arrangement.isModified = false;
          self.arrangement.selected = this.arrangement.temporary.map((obj) => ({
            ...obj,
          }));
          self.getServiceArrangementProgramMeasure();
          self.fetchSelectedArrangementList();
        })
        .catch((errm) => {
          self.ShowToast(errm.message, '', 'error');
        });
    },
    removeFromArrangementList(item) {
      const self = this;
      let params = {};

      params.peiId = store.state.peiSelected;
      params.peiCode = item.arrangementId;

      self
        .$ApiDelete('api/pei/DeletePeiServiceArrangement', params)
        .then(() => {
          self.arrangement.selected.splice(
            self.arrangement.selected.indexOf(item),
            1
          );

          if (self.arrangement.temporary.length > 0) {
            self.arrangement.temporary.splice(
              this.arrangement.temporary.indexOf(item),
              1
            );
          }
          self.getServiceArrangementProgramMeasure();
          self.fetchSelectedArrangementList();
        })
        .catch((errm) => {
          self.ShowToast(errm.message, '', 'error');
        });
    },
    // END Arrangements

    // START Service Modifications
    fetchServiceModifications() {
      const self = this;
      self
        .$ApiGet(
          `api/pei/getpeiservicemodifications/${store.state.peiSelected}`
        )
        .then((response) => {
          self.modifications = response.data;
        })
        .catch((errm) => {
          self.ShowToast(errm.message, '', 'error');
        });
    },
    // END Service Modifications
    // Validations.
    // Validation for Learning Arrangement.
    validateLearningArrangement() {
      let activate =
        this.model.placementFlag === '1' && this.validationTriggered.validation;
      let throwValidate = this.arrangement.selected.length <= 0;
      return activate && throwValidate;
    },
    validateWithtoutArrangement() {
      let result = false;
      if (this.model.placementFlag) {
        result = this.model.placementFlag === '0';
      }
      return result;
    },
    // Validation for measurement program with placement.
    validateMeasurementProgramStudent() {
      let activate =
        this.peiOtherServMeasureCode.isRegular &&
        this.model.otherServMeasurePlacementFlag === '1' &&
        this.validationTriggered.validation;

      let throwValidate = this.programMeasurementList.length <= 0;

      return activate && throwValidate;
    },
    // Validation for needs.
    validateNeedsStudent() {
      return (
        this.validationTriggered.validation && this.needsStudentList.length <= 0
      );
    },
    async loadResources() {
      let resourceCodes = ['6006', '6010', 'R03200110', 'R03200109'];

      this.validationMessages = await resourcesService.LoadValidationMessages(
        resourceCodes
      );
    },
    async getActivateAssistantServiceNeedGuidearameter() {
      const academicYearId = store.getters.getPeiInfo.academicYearId;
      const { data } = await getSysparameterByNames({
        parameterNames: ['ActivateAssistantServiceNeedGuide'],
        academicYearId,
      });
      this.activateAssistantServiceNeedGuideIsOn =
        data[0]?.staticValue == 'true';
    },
    async getAreasForPei(peiId) {
      try {
        const { data } = await this.$ApiGet(
          `/api/pei/getassociatedpeiprogramserviceareas?peiId=${peiId}`
        );
        return data;
      } catch (err) {
        console.error(err);
        return null;
      }
    },
    async getProgramServiceSummary(programServiceAreaId) {
      try {
        const { data } = await this.$ApiGet(
          `api/pei/getprogramserviceareasummary/${programServiceAreaId}`
        );
        return data;
      } catch (err) {
        console.error(err);
        return null;
      }
    },
    async getStudentImpediments(studentSieId) {
      try {
        const { data } = await studentService.getAllStudentImpediments(
          studentSieId
        );
        return data || [];
      } catch (err) {
        console.error(err);
        return [];
      }
    },
    async validateStudentHasInterventionPlanInOrientationAndMobility() {
      const peiAreas = await this.getAreasForPei(this.selectedPeiId);

      if (!peiAreas) return false;

      const orientationAndMobilityArea = peiAreas.find(
        (x) => x.areaId === peiProgramAreas.OrientacionMovilidad
      );

      if (!orientationAndMobilityArea?.id) return false;

      const areaSummary = await this.getProgramServiceSummary(
        orientationAndMobilityArea.id
      );

      return (
        areaSummary.selectedGoalsWithObjectives.length &&
        areaSummary.selectedNecessities.length &&
        areaSummary.selectedProcedures.length &&
        areaSummary.selectedStrengths.length
      );
    },
    async validateStudentHasHearingLossOrVisualDisability() {
      const data = await this.getStudentImpediments(
        this.selectedStudent.studentId
      );
      return data?.some((x) =>
        [
          ImpedimentEnum.ImpedimentoVisual,
          ImpedimentEnum.SordoCiego,
          ImpedimentEnum.ImpedimentosMultiples,
        ].includes(x.id)
      );
    },
  },
  components: {
    SectionTitle,
    CustomTextArea,
    SaveObserver,
    StrongTitle,
    LearningArrangement,
    MeasurementProgramStudent,
    MeasurementProgramStudentAdd,
    NeedsStudent,
    NeedsStudentAdd,
    Hygiene,
    Nutrition,
    Mobility,
    Communication,
    Health,
    Transportation,
    ModificationsProgramStudent,
    ValidationObserver,
    ValidationProvider,
    Error,
  },
  computed: {
    isOtherServMeasureCodeNoApplicable() {
      const otherCodes = [
        peiOtherServMeasuresEnum.Regular,
        peiOtherServMeasuresEnum.EvaluacionAlterna,
      ];
      return (
        this.model.peiOtherServMeasureCode ===
          peiOtherServMeasuresEnum.NoApplicable ||
        !otherCodes.includes(this.model.peiOtherServMeasureCode)
      );
    },
    selectedPeiId() {
      return store.getters.SelectedPei;
    },
    selectedStudent() {
      return store.getters.SelectedStudent;
    },
    isDraft() {
      return store.getters.SelectedPeiStatus == peiStatuses.Borrador;
    },
    isPsc() {
      return store.getters.getIsPsc;
    },
    showSectionOfAssistanceWhenIsSigned() {
      return (
        (store.getters.SelectedPeiStatus.toString() == peiStatuses.Firmado ||
          store.getters.SelectedPeiStatus.toString() ==
            peiStatuses.Completado) &&
        this.wasSignedWithaAssistantServiceNeedGuide
      );
    },
    isReadonlyWithAmendmentSectionI() {
      if (this.isDraft) {
        return false;
      }
      return !(this.canUseTabEditRestriction && !this.admendmentIsEmpty);
    },
    validationTriggered() {
      return store.getters.getPeiValidationTriggered;
    },
    controversyVI() {
      return store.getters.getPeiControversies(peiSections.VI);
    },
    hasHygieneNeeds() {
      return this.needsStudentList.some(
        (n) => n.id === peiServiceNeeds.Hygiene
      );
    },
    hasNutritionNeeds() {
      return this.needsStudentList.some(
        (n) => n.id === peiServiceNeeds.Nutrition
      );
    },
    hasMobilityNeeds() {
      return this.needsStudentList.some(
        (n) => n.id === peiServiceNeeds.Mobility
      );
    },
    hasCommunicationNeeds() {
      return this.needsStudentList.some((n) =>
        CommunicationOptions.includes(n.id)
      );
    },
    hasHealthNeeds() {
      return this.needsStudentList.some((n) => healtNeedsCodes.includes(n.id));
    },
    hasTransportationNeeds() {
      return this.needsStudentList.some(
        (n) => n.id === peiServiceNeeds.Transportation
      );
    },
    showNeedsSection() {
      return (
        this.sysParameters.length > 0 &&
        this.sysParameters
          .find((p) => p.name === 'PEIServicesNeedsSAEE10')
          ?.staticValue.toLowerCase() === 'true' &&
        this.needsStudentList.some(
          (n) =>
            Object.values(peiServiceNeeds).includes(n.id) &&
            n.id != peiServiceNeeds.IsNotRequired
        )
      );
    },
    inapropriateConductMessage() {
      let hasHealthNeedsConduct = this.needsStudentList.some(
        (x) => x.id == peiServiceNeeds.healthsupportForHealthNeeds
      );
      let message = '';
      /* if(this.validationTriggered.validation && this.hasInapropriateConduct && !hasHealthNeedsConduct){
        message = "Al marcar Sí en la pregunta ¿El estudiante muestra conducta inapropiada?, será requerido que documente el Asistente para cuidados de salud-Apoyo Conductual.";
      }*/

      if (
        this.validationTriggered.validation &&
        !this.hasInapropriateConduct &&
        hasHealthNeedsConduct
      ) {
        message =
          'Al seleccionar Asistente para cuidados de salud- Apoyo conductual, será requerido contestar Sí a la pregunta  ¿El estudiante muestra conducta inapropiada?.';
      }

      return message;
    },
    validateSAEE10Form() {
      return this.validationTriggered.validation;
    },
    admendmentIsEmpty() {
      return this.$store.state['$_admendment'].sections.length == 0;
    },
    canUseTabEditRestriction() {
      return (
        this.$store.state['$_admendment'].correlationParameter[0]
          .staticValue === 'true'
      );
    },
    hasSubSectionFinAmendant() {
      return this.$store.state['$_admendment'].sections.some(
        (x) => x.subSectionId == SUB_SECTION_F
      );
    },
    hasSubSectionGinAmendant() {
      return this.$store.state['$_admendment'].sections.some(
        (x) => x.subSectionId == SUB_SECTION_G
      );
    },
    hasSubSectionIinAmendant() {
      return this.$store.state['$_admendment'].sections.some(
        (x) => x.subSectionId == SUB_SECTION_I
      );
    },
    hasSubSectionJinAmendant() {
      return this.$store.state['$_admendment'].sections.some(
        (x) => x.subSectionId == SUB_SECTION_J
      );
    },
    getStudentFunctionData() {
      return this.studentFunctionData || {};
    },
    isInapropriateConductChecked() {
      return this.hasInapropriateConduct;
    },
    selectedInappropriateConductAlternative() {
      return this.getStudentFunctionData?.inappropriateConductAlternative;
    },
    canShowSaee10Section() {
      return (
        this.showNeedsSection &&
        !(this.isDraft && this.activateAssistantServiceNeedGuideIsOn) &&
        !this.showSectionOfAssistanceWhenIsSigned
      );
    },
  },
  watch: {
    healthModel: {
      handler: (val) => {
        setFormDef(val);
      },
      deep: true,
    },
    hygieneModel: {
      handler: (val) => {
        setFormDef(val);
      },
      deep: true,
    },
    nutritionModel: {
      handler: (val) => {
        setFormDef(val);
      },
      deep: true,
    },
    mobilityModel: {
      handler: (val) => {
        setFormDef(val);
      },
      deep: true,
    },
    communicationModel: {
      handler: (val) => {
        setFormDef(val);
      },
      deep: true,
    },
    'model.serviceNeedsComments': {
      handler: (val) => {
        let data = val != '' ? val : '--';
        setFormDef(data);
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
.separator-space {
  margin-top: 40px;
}

.service-assistance-needs-title {
  background-color: #d3dbd7;
}

.service-assistance-needs-title > i {
  font-size: 1.4em;
}

.service-assistance-needs-title > h3 {
  font-size: 18px;
  font-weight: bold;
}

.custom-checkbox .custom-control-input:checked ~ .custom-control-label::before {
  background-color: #28a474 !important;
}

.footer-success {
  margin: 8px !important;
}

::v-deep .custom-radio-container {
  justify-content: end;
}
</style>
